import Button, { BUTTON_TYPES } from "../components/Button";
import CheckboxInput from "../components/inputs/CheckboxInput";
import DateInput from "../components/inputs/DateInput";
import Dropdown from "../components/inputs/Dropdown";
import FileInput from "../components/inputs/FileInput";
import NumberInput from "../components/inputs/NumberInput";
import PhoneInput from "../components/inputs/PhoneInput";
import RadioInput from "../components/inputs/RadioInput";
import SearchInput from "../components/inputs/SearchInput";
import TextInput from "../components/inputs/TextInput";
import Page from "../components/Page";

const ComponentsPage = () => {
    return (
        <Page>
            <h1>React Components and Styling Reference</h1>            
            <h2>Buttons</h2>
            <p>Primary button - purple background, white text</p>
            <Button
                id="componentsPage-primaryBtn"
                type={BUTTON_TYPES.primary}
                buttonText="Primary Button"
                action={() => console.log('Primary Button')} 
            ></Button>
            <p>Outline button - white background, purple text, purple outline</p>
            <Button 
                id="componentsPage-outlineBtn"
                type={BUTTON_TYPES.outline}
                buttonText="Outline Button"
                action={() => console.log('Outline Button')} 
            />
            <p>Danger button - red background, white text</p>
            <Button
                id="componentsPage-dangerBtn"
                type={BUTTON_TYPES.danger}
                buttonText="Danger Button"
                action={() => console.log('Danger Button')} 
            />
            <h2>Inputs</h2>
            <p>Text Input - width will be controlled by screen size and parent container width</p>
            <TextInput
                id="componentsPage-textInput"
                placeholder="Sample Text"
                label="Input Label"
            />
            <p>Search Input - width will be controlled by screen size and parent container width</p>
            <SearchInput
                id="componentsPage-searchInput"
                placeholder="Search..."
            />
            <p>Checkbox Input</p>
            <div>
                <CheckboxInput
                    id="componentsPage-checkbox1"
                    name="componentsPageCheckboxes"
                    value="Checkbox 1"
                />
                <CheckboxInput
                    id="componentsPage-checkbox2"
                    name="componentsPageCheckboxes"
                    value="Checkbox 2"
                />
                <CheckboxInput
                    id="componentsPage-checkbox3"
                    name="componentsPageCheckboxes"
                    value="Checkbox 3"
                />
            </div>
            <p>Date Input</p>
            <DateInput
                id="componentsPage-dateInput"
                label="Date"
            />
            <p>File Input</p>
            <FileInput
                id="componentsPage-fileInput"
                buttonText="Upload a File"
                acceptedFiles=".pdf"
            />
            <p>Number Input</p>
            <NumberInput
                id="componentsPage-numberInput"
                label="Enter Number"
                min={0}
                max={9999}
            />
            <p>Radio Input</p>
            <div>
                <RadioInput
                    id="componentsPage-radioBtn1"
                    name="componentsPageRadioBtns"
                    value="Option 1"
                />
                <RadioInput
                    id="componentsPage-radioBtn2"
                    name="componentsPageRadioBtns"
                    value="Option 2"
                />
                <RadioInput
                    id="componentsPage-radioBtn3"
                    name="componentsPageRadioBtns"
                    value="Option 3"
                />
            </div>
            <p>Phone Input</p>
            <PhoneInput
                id="componentsPage-phoneInput"
                placeholder="123-456-7890"
                label="Phone Number"
            />
            <p>Dropdown</p>
            <Dropdown 
                id="componentsPage-dropdown"
                name="componentsPageDropdown"
                label="Sample Dropdown"
                options={
                    [
                        { 
                            value: 'option1',
                            label: 'Option 1',
                        },
                        { 
                            value: 'option2',
                            label: 'Option 2',
                        },
                        { 
                            value: 'option3',
                            label: 'Option 3',
                        },
                    ]
                }
            />
        </Page>
    );
};

export default ComponentsPage;